import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import Table from 'antd/lib/table';
import Select from 'antd/lib/select';
import { ResponsiveTable } from '../../../common/components/data-display';
import { investmentStatusT } from '../../../common/enums';
import { Row, Col } from 'react-flexbox-grid';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';

const { Column } = Table;
const { Option } = Select;

@translate()
export default class InvestmentList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    investments: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  render() {
    const {
      investments,
      pagination,
      filter,
      onTableChange,
      onFilterStatusChange,
      isLoading,
      t,
    } = this.props;

    return (
      <div>
        <Row className="filters padded">
          <Col xs={12} sm={4}>
            <Select
              placeholder={t('Vybrať stav')}
              onChange={onFilterStatusChange}
              defaultValue={filter.status}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(investmentStatusT).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        <ResponsiveTable
          dataSource={investments}
          rowKey={investment => investment.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        >
          <Column
            title={t('Suma')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column
            title={t('Stav')}
            dataIndex="status"
            key="status"
            render={status => investmentStatusT[status]}
          />
          <Column
            title={t('Dátum vytvorenia')}
            dataIndex="createdAt"
            key="createdAt"
            render={createdAt => formatDateTime(createdAt)}
          />
          <Column
            title={t('Akcie')}
            key="action"
            render={(text, investment) => (
              <span>
                <Link to={`/admin/loans/${investment.LoanId}`}>{t('Detail pôžičky')}</Link>
              </span>
            )}
          />
        </ResponsiveTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/investment-management/components/InvestmentList.js